<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container" (keydown)="keyDownFunction($event)">
    <div class="row">
        <div class="col-24">
            <h1 class="medium">Section 4: Coordination of Benefits</h1>
        </div>
    </div>

    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="hasError">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages"><button>{{error}}</button></li>
                </ul>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-16">
            <p class="required">Todos los campos son obligatorios, a menos que estén marcados como opcionales.</p>
        </div>
    </div>


    <div class="row">
        <div class="col-16">
            <fieldset class="radio">
                <legend class="blue-text">¿Tiene {{spnIsBeneficiary}} cobertura de medicamentos con receta que no sea la de Medicare, como:<br /><br /> seguro privado, TRICARE, cobertura de beneficios de salud para empleados federales, programas de beneficios del Departamento de Asuntos de Veteranos o Programas Estatales de Asistencia Farmacéutica?</legend>
                <ValidatedRadioButtonGroup [options]="rblSecondaryCoverage"
                                           [radioGroupName]="'rblSecondaryCoverage'"
                                           [selectedValue]="enrollmentViewModel.OTHCVRG"
                                           (onValueChange)="ShowCoverageInfo($event)">
                </ValidatedRadioButtonGroup>
            </fieldset>
        </div>
    </div>

    <div *ngIf="IsCovergInfoYes">
        <div class="row">
            <div class="col-16">
                <p class="blue-text">
                    ¿Podría brindarme los siguientes datos que figuran en la tarjeta de identificación suya o de la persona inscrita?
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Nombre de la otra cobertura'"
                                        [text]="enrollmentViewModel.OTHCVRGNAME"
                                        [validators]="[]"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollmentViewModel.OTHCVRGNAME = $event">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <label>Fecha de finalización de la otra cobertura (Opcional)</label>
                    <JQDatePicker [selectedDate]="enrollmentViewModel.COBTERMDT"
                                  (elementClicked)="enrollmentViewModel.COBTERMDT = $event">
                    </JQDatePicker>
                    <!--<ValidatedDateTextField label="Termination Date for this coverage"
                                            [date]="enrollmentViewModel.COBTERMDT"
                                            (onDateChange)="enrollmentViewModel.COBTERMDT = $event"
                                            [validators]="[dateTextFieldValidator]"
                                            [disabled]="disabled">
                    </ValidatedDateTextField>-->
                </div>

            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'N.º de identificación de esta cobertura (Opcional)'"
                                        [text]="enrollmentViewModel.OTHCVRGID"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollmentViewModel.OTHCVRGID = $event">

                    </ValidatedTextField>
                </div>

            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'N.º de grupo de esta cobertura (Opcional)'"
                                        [text]="enrollmentViewModel.OTHCVRGGRP"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollmentViewModel.OTHCVRGGRP = $event">

                    </ValidatedTextField>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'N.º de identificación bancaria (BIN) (Opcional)'"
                                        [text]="enrollmentViewModel.COBBIN"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollmentViewModel.COBBIN = $event">

                    </ValidatedTextField>
                </div>

            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'N.º de control de procesador (PCN) (Opcional)'"
                                        [text]="enrollmentViewModel.COBPCN"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollmentViewModel.COBPCN = $event">

                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper bottom-10">
                    <label>Fecha de entrada en vigor de la cobertura (Opcional)</label>
                    <JQDatePicker [selectedDate]="enrollmentViewModel.COBEFFDT"
                                  (elementClicked)="enrollmentViewModel.COBEFFDT = $event">
                    </JQDatePicker>
                    <!--<ValidatedDateTextField label="Effective Date for this coverage"
                                            [date]="enrollmentViewModel.COBEFFDT"
                                            (onDateChange)="enrollmentViewModel.COBEFFDT = $event"
                                            [validators]="[dateTextFieldValidator]"
                                            [disabled]="disabled">
                    </ValidatedDateTextField>-->
                </div>

            </div>
        </div>
    </div>
    <div class="row" style="clear:left;display:flex;">
        <div class="col-16">
            <fieldset class="radio">
                <legend class="blue-text">¿La dirección permanente indicada corresponde a un centro de cuidado a largo plazo, como un hogar de ancianos o un centro de residencia asistida?</legend>
                <ValidatedRadioButtonGroup [options]="rbllongTerm"
                                           [selectedValue]="enrollmentViewModel.RBLLONGTERM"
                                           [radioGroupName]="'rbllongTerm'"
                                           (onValueChange)="ShowrbllongtermOptions($event)">
                </ValidatedRadioButtonGroup>
            </fieldset>
        </div>
    </div>
    <fieldset class="radio" *ngIf="IsRbllongtermYes">
        <legend class="blue-text bottom-10 limit-width">¿Podría decirme el nombre y el número teléfono de la institución?</legend>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField label="Nombre de la Institución"
                                        [maxlength]="50"
                                        [text]="enrollmentViewModel.LTCFACILITY"
                                        (onValueChange)="enrollmentViewModel.LTCFACILITY= $event"
                                        [disabled]="disabled">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField label="Número de teléfono (solo números)"
                                        [maxlength]="10"
                                        [text]="enrollmentViewModel.LTCPHONE"
                                        (onValueChange)="enrollmentViewModel.LTCPHONE= $event"
                                        [validators]="[]"
                                        [disabled]="disabled">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
    </fieldset>
    <div>
        <div class="row" style="clear:none;">
            <div class="col-16">
                <fieldset class="radio">
                    <!--<legend class="blue-text" *ngIf="!ShowCurrentYearScript">Would {{spnIsBeneficiary}} like to receive written communications and plan documents from SilverScript in English or Spanish?</legend>
    <legend class="blue-text" *ngIf="ShowCurrentYearScript">
        This information is available for free in other languages. <br />
        Would {{spnIsBeneficiary2}} prefer we send information in a language other than English, or in an alternate format?
        <br /><br />What is the format preference?
    </legend>-->
                    <legend class="blue-text" *ngIf="ShowCurrentYearScript">
                        La información del plan está disponible de manera gratuita en otros idiomas y en formatos accesibles. <br /><br />
                        ¿Quiere recibir comunicados escritos y documentos del plan de Aetna en un idioma que no sea inglés?
                        <br /><br />¿En qué idioma los prefiere?
                    </legend>
                    <legend class="blue-text" *ngIf="!ShowCurrentYearScript">
                        La información del plan está disponible de manera gratuita en otros idiomas y en formatos accesibles. También puede obtener acceso en línea al Resumen de beneficios, que incluye más información sobre estos y las calificaciones con estrellas, en <a href="https://www.aetnamedicare.com" target="_blank">https://www.aetnamedicare.com</a> Todos los años, Medicare evalúa los planes según un sistema de calificación de 5 estrellas. <br /><br />
                        ¿Quiere recibir comunicados escritos y documentos del plan de Aetna en un idioma que no sea inglés?
                        <br /><br />¿En qué idioma los prefiere?
                    </legend>
                    <!--<legend class="blue-text" *ngIf="!ShowCurrentYearScript">
        This information is available for free in other languages. <br />
        Would {{spnIsBeneficiary}} like to receive written communications and plan documents from Aetna in English or Spanish?
        <br /><br />What is the format preference?
    </legend>-->
                    <ValidatedRadioButtonGroup [selectedValue]="enrollmentViewModel.LANG"
                                               [options]="rblLanguage"
                                               [radioGroupName]="'rblLanguage'"
                                               (onValueChange)="enrollmentViewModel.LANG = $event">
                    </ValidatedRadioButtonGroup>
                    <br />
                    <legend class="blue-text">
                        ¿Quiere recibir comunicados escritos y documentos del plan de Aetna en un formato accesible (por ejemplo, CD de audio, letra grande o braille)?  <br />
                    </legend>
                    <ValidatedRadioButtonGroup [options]="optionaccessibility"
                                               [selectedValue]="accessibilityValue"
                                               (onValueChange)="onAccessibilityChanges($event)"
                                               [radioGroupName]="'Langformat'">
                    </ValidatedRadioButtonGroup>
                    <br />
                    <legend class="blue-text">
                        Llámenos al 1-855-338-7027 (TTY: 711) si necesita información en otro idioma o formato. Estamos aquí 24 hours a day, 7 days a week.
                    </legend>
                </fieldset>
            </div>
        </div>
        <!--<div class="row">
        <div class="col-16">
            <fieldset class="radio">
                <!-- <legend class="blue-text">
                     <!--Once {{spnyourhisher}} application is complete, would {{spnIsBeneficiary}} like to receive {{spnyourhisher}} documents electronically?  By going paperless, {{spnyouheshe}}
                 can keep {{spnyourhisher}} documents organized in one secure location, accessible online 24/7, 365 days a year. 
                 By selecting this option {{spnyouheshe}}
                 {{spnIsAre}} choosing to receive all currently available and future documents online. We will notify {{spnyouhimher}}
                 each time {{spnyouheshe}} {{spnHasHave}} a document available to view.  The type of documents {{spnyouheshe}} will be eligible to receive digitally are:-->
        <!-- Once {{spnyourhisher}} application is complete, would {{spnIsBeneficiary}} like to receive Medicare Part D documents electronically? This lets {{spnyouhimher}} keep {{spnyourhisher}} documents organized in one secure online location that’salways accessible.
                        w"
                        <div class="row">
                            <br />
                        </div>
                        iv
                        <p>
                            The types of documents include evidence of coverage, your formulary, a pharmacy directory, explanation of benefit statements, plan coverage information, billing information and general plan information and messaging. You can go back to mailed versions at any time.
                        </p>
                        <!--<div class="row">
                        Do you want paperless documents?
                    </div>
                    </legend>
                    <div class="blue-text">
                        [Al recibir los documentos en forma electrónica, {{spnyouheshe}}
                        puede tenerlos organizados en un lugar seguro y consultarlos las 24 horas del día, los 7 días de la semana, los 365 días del año. Cuando selecciona esta opción, {{spnyouheshe}}
                        elige recibir en línea todos los documentos que están disponibles ahora, y que estarán disponibles en el futuro. Le avisaremos cada vez que {{spnyouheshe}}
                        tenga un documento para consultar. Estos son los tipos de documentos que {{spnyouheshe}}
                        podrá recibir en línea:
                        <div class="qtip-list" style="padding:25px">
                            <ul>
                                <li>
                                    Paquete de bienvenida (Evidencia de cobertura, Formulario y Directorio de farmacias).
                                </li>
                                <li>
                                    Notificación anual de cambios (Evidencia de cobertura, Formulario y Directorio de farmacias).
                                </li>
                                <li>
                                    Explicación de beneficios.
                                </li>
                                <li>
                                    Información sobre la cobertura del plan.
                                </li>
                                <li>
                                    Información de facturación.
                                </li>
                                <li>
                                    Información y mensajes generales del plan.
                                </li>
                            </ul>
                        </div>
                        ¿Quiere recibir los documentos en forma electrónica?
                    </div>
                    <ValidatedRadioButtonGroup [options]="rdBtnEOB"
                                               [selectedValue]="enrollmentViewModel.EOB"
                                               [radioGroupName]="'rdBtnEOB'"
                                               (onValueChange)="ShowEobEmail($event)">
                    </ValidatedRadioButtonGroup>
                </fieldset>
            </div>
        </div>-->
        <div class="row">
            <div class="col-16">
                <fieldset class="radio">
                    <div class="blue-text">
                        ¿Quiere recibir la Explicación de beneficios (EOB) en formato digital?<br />
                        Le enviaremos un correo electrónico cada mes para indicarle cómo acceder a la EOB segura y cómo verla. Tendrá que proporcionar su dirección de correo electrónico.  Puede elegir dejar de recibir correos electrónicos en cualquier momento.


                    </div>
                    <!-- <legend class="blue-text" *ngIf="ShowCurrentYearScript">
        Una vez que su solicitud esté completa, ¿le gustaría recibir los documentos de la Parte D de Medicare de forma electrónica? Esto le permite mantener sus documentos organizados en una ubicación en línea segura a la que siempre se puede acceder.
        <br />
        <br />
        Los tipos de documentos incluyen evidencia de cobertura, su formulario, un directorio de farmacias, explicación de las declaraciones de beneficios, información de cobertura del plan, información de facturación e información y mensajes generales del plan. Puede volver a las versiones enviadas por correo en cualquier momento.
    </legend>-->
                    <div class="bottom-20">
                        <ValidatedCheckbox [id]="'EOBoption'"
                                           [label]="'Sí, quiero recibir la EOB de forma electrónica.'"
                                           [checked]="IsEobYes"
                                           (onValueChange)="ShowEobEmail($event)">
                        </ValidatedCheckbox>
                    </div>
                    <!-- <legend class="blue-text" *ngIf="ShowCurrentYearScript">
        Una vez que se inscribe, o si ya es un miembro recurrente, puede volver a las versiones enviadas por correo en cualquier momento en <a class="link" href="https://www.caremark.com/">Caremark.com</a>.
    </legend>-->
                </fieldset>
            </div>
        </div>
        <div *ngIf="IsEobYes">
            <div class="row">
                <div class="col-8">
                    <p class="qtip-note"><strong>qTip Note:</strong> May I please have your email address?</p>
                    <div class="input-wrapper">
                        <ValidatedTextField class="" [maxlength]="40"
                                            [label]="'Email Address'"
                                            id="EmailAddress"
                                            [text]="enrollmentViewModel.APPEMAIL"
                                            (onValueChange)="enrollmentViewModel.APPEMAIL = $event">

                        </ValidatedTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <div class="bottom-20">
                        <p>
                            Usaremos su dirección de correo electrónico para mantenerlo actualizado sobre su plan SilverScript.
                            Usted puede optar por salir en cualquier momento.
                        </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <p class="blue-text">                        
                        Ingrese al centro de preferencias en línea, en <a href="http://www.aetnamedicare.com" target="_blank"> aetnamedicare.com</a>; complete la inscripción haciendo clic en la opción para iniciar sesión y siguiendo los pasos de inscripción.  Consulte qué documentos están disponibles para recibir de forma digital y administre las preferencias de envío de documentos de forma digital o por correo postal. Podrá optar por volver a recibir los documentos impresos en cualquier momento. Tenga en cuenta que, para algunos documentos, el cambio al envío en formato digital puede tardar hasta dos meses. ¡Gracias por optar por el formato digital!


                    </p>
                </div>
                <!--<div class="col-16">
                <!-- <p class="blue-text">By providing us with {{spnyourhisher}} email address, {{spnyouheshe}} agree{{spnIsReside}} to receive email communications from SilverScript until {{spnyouheshe}} opt{{spnIsReside}} out of further emails. {{spnYouheshe}} {{spnHasHave}} the opportunity to opt-out at any time.
                To view {{spnyourhisher}} Documents {{spnyouheshe}} will need to create an account on Caremark.com once {{spnyouheshe}} {{spnHasHave}} received {{spnyourhisher}} enrollment confirmation letter. If {{spnyouheshe}} {{spndodoes}} not register for an account on Caremark.com {{spnyouheshe}} will receive {{spnyourhisher}} Documents by mail.
                <!--To view {{spnyourhisher}} Explanation of Benefits {{spnyouheshe}} will need to create an account on Caremark.com once {{spnyouheshe}} {{spnHasHave}} received {{spnyourhisher}} enrollment confirmation letter. If {{spnyouheshe}} {{spndodoes}} not register for an account on Caremark.com {{spnyouheshe}} will receive {{spnyourhisher}} Explanation of Benefits by mail.-->
                <!-- </p>
                </div>-->
            </div>
        </div>
        <div class="row" *ngIf="IsEobNo">
            <div class="col-16">
                <p class="blue-text">
                    La fecha propuesta de entrada en vigor de la cobertura suya o de la persona inscrita es {{effectiveDate}}.
                </p>
            </div>
        </div>
        <div class="row" style="clear: left; display:flex;">
            <div class="col-16">
                <fieldset class="radio">
                    <legend class="blue-text">Es {{spnIsBeneficiaryYou}} la persona inscrita miembro de un plan Medicare Advantage, como un plan de HMO o PPO?</legend>
                    <ValidatedRadioButtonGroup [options]="rdlHMO"
                                               [selectedValue]="enrollmentViewModel.RBLHMO"
                                               (onValueChange)="ShowOptionsHMO($event)"
                                               [radioGroupName]="'rdlHMO'">
                    </ValidatedRadioButtonGroup>
                </fieldset>
            </div>
        </div>
        <div class="row" *ngIf="IsRdlHMOYes">
            <div class="col-16">
                <p class="blue-text">
                    Si {{spnIsBeneficiary}} es miembro de un plan Medicare Advantage (como un plan de HMO o de PPO), es posible que ya tenga la cobertura de medicamentos con receta de su plan Medicare Advantage.


                </p>
                <p class="blue-text bottom-20"> Al inscribirse en Aetna, su membrecía en el plan Medicare Advantage podría finalizar. Esto afectará su cobertura médica y hospitalaria, y su cobertura de medicamentos con receta. Lea la información que su plan le envíe. Si {{spnIsBeneficiaryYou}} tiene preguntas, comuníquese con el proveedor del plan.</p>
                <!--<p class="blue-text bottom-20" *ngIf="!ShowCurrentYearScript">By enrolling in Aetna, {{spnYourenrollee}} Medicare Advantage Plan membership may end. This will affect {{spnyourhisher}} doctor and hospital coverage as well as your prescription drug coverage. Please read the information that {{spnyourhisher}} plan sends you.  If {{spnIsBeneficiaryYou}} {{spnHasHave}} questions, contact the plan provider.</p>-->
            </div>
        </div>
        <div class="row" style="clear:left;display:flex;">
            <div class="col-16">
                <fieldset class="radio">
                    <legend class="blue-text">¿Tendrá {{spnIsBeneficiaryYou}} cobertura de salud de parte de un empleador o de un sindicato durante el mismo tiempo para el cual busca obtener cobertura en Aetna?</legend>
                    <!--<legend class="blue-text" *ngIf="!ShowCurrentYearScript">{{spnDoDoes}} {{spnIsBeneficiaryYou}} have health coverage from an employer or union during the same time you are looking for coverage from Aetna?</legend>-->
                    <ValidatedRadioButtonGroup [options]="rblRep"
                                               [selectedValue]="enrollmentViewModel.RBLHEALTHCOVERAGE"
                                               (onValueChange)="ShowGroupOptionsHEALTHCOVERAGE($event)"
                                               [radioGroupName]="'rblRep'">
                    </ValidatedRadioButtonGroup>
                </fieldset>
            </div>
        </div>
        <div class="row" *ngIf="IsRblRepYes" style="clear:left;">
            <div class="col-16">
                <p class="blue-text bottom-20" *ngIf="ShowCurrentYearScript">Es importante comprender que si {{spnIsBeneficiary}} recibe actualmente cobertura de salud de parte de un empleador o un sindicato, podría perder sus beneficios al inscribirse en Aetna. Lea los comunicados que le envían su empleador o el sindicato. Si aún tiene preguntas, comuníquese con el gerente de beneficios de salud de su empleador o del sindicato.</p>
                <p class="blue-text bottom-20" *ngIf="!ShowCurrentYearScript">Es importante comprender que si {{spnIsBeneficiary}} recibe actualmente cobertura de salud de parte de un empleador o un sindicato, podría perder sus beneficios al inscribirse en Aetna. Lea los comunicados que le envían su empleador o el sindicato. Si aún tiene preguntas, comuníquese con el gerente de beneficios de salud de su empleador o del sindicato." with"Si actualmente tiene cobertura de salud de un empleador o de un sindicato, inscribirse en {{this.enrollmentViewModel.PLANTYPENAME}} podría afectar esos beneficios. Podría perder la cobertura de salud de su empleador o sindicato si se inscribe en {{this.enrollmentViewModel.PLANTYPENAME}} Lea los comunicados que le envían su empleador o el sindicato. Si tiene preguntas, visite su sitio web o comuníquese con la oficina que figura en los comunicados. Si no hay información de contacto, puede pedir ayuda a su administrador de beneficios o en la oficina que se encarga de responder preguntas sobre la cobertura..</p>
                <!--<p class="blue-text bottom-20" *ngIf="!ShowCurrentYearScript">It’s important to understand that if {{spnIsBeneficiary}} currently {{spnHasHave}} health coverage from an employer or union, {{spnIsBeneficiary}} could lose those benefits by enrolling in Aetna. Please read the communications about health benefits that {{spnIsEmployeeYour}} employer or union sends {{spnyouhimher}}. If {{spnyouheshe}} still {{spnHasHave}} questions, please contact {{spnyourhisher}} employer or union health benefits manager.</p>-->
            </div>
        </div>
    </div>

    <div id="divValidPeriodNo" [hidden]="!IsRblvalidPeriodNo">
        <div class="row">
            <div class="col-16">
                <p class="blue-text">
                    Unfortunately, {{spnYoutheenrollee}} {{spnIsAre}} not eligible to join Aetna as there is no valid enrollment period available. I will not be able to take an enrollment for {{spnYoutheenrollee}} in Aetna at this time. Please call back when your enrollment period becomes valid.
                </p>
            </div>
        </div>
        <div class="col-16" *ngIf="isQtip">
            <p class="qtip-note"><strong>qTip Note:</strong> Answer questions as applicable, then proceed to <u>“Section 6. Enrollment End”</u>. Disposition as Ineligible – Invalid Enrollment Period. <a (click)="SalesBenfDetails()"><strong> Click here</strong></a></p>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary" *ngIf="showsubmit" (click)="formSubmit()">Continue</button>
            <button class="button cancel" (click)="onBack()">Back</button>
        </div>
    </div>
</div>
